import { RefObject } from "react";

import { Optional } from "../enums/types";

export const isEventTriggeredInElement = (
  elementRef: RefObject<Optional<HTMLElement>>,
  event: Event
): boolean =>
  event.target instanceof Node &&
  elementRef !== null &&
  elementRef.current !== null &&
  elementRef.current.contains(event.target);

export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
